module.exports = __webpack_public_path__ + "media/app/assets/races/goblin_male-5d74e940f5a9d17856d4f85f69341917.png";